/**
 * "What just happened?" explainer shown right after the BadUSB / juice-jacking
 * exfil cinematic (ChargeExfil), BEFORE the learner is handed the safe-charging
 * choice. Previously clicking "What just happened?" just cut straight to the
 * next stage with no actual explanation -- this is the real explainer, with a
 * generated illustration, that the learner asked for.
 */
export function BadUsbExplain({ onContinue }: { onContinue: () => void }) {
  return (
    <div className="bue-wrap" role="dialog" aria-label="What just happened">
      <div className="bue-card">
        <div className="bue-copy">
          <div className="bue-kicker">WHAT JUST HAPPENED</div>
          <h2>The cable itself was the attack</h2>
          <p className="bue-lede">
            No file was opened and no link was clicked. Plugging the phone into that public USB
            port was the entire attack — a USB connector carries data as well as power, and that
            port used it.
          </p>
          <div className="bue-block">
            <h3>BadUSB</h3>
            <p>
              A tiny chip hidden inside a cable or charging station can pretend to be a keyboard
              the instant it&apos;s plugged in. It types its own hidden commands — no permission
              dialog, no click to approve, no file to open.
            </p>
          </div>
          <div className="bue-block">
            <h3>Juice jacking</h3>
            <p>
              Public USB ports and &quot;charging&quot; cables can carry a live data connection
              alongside power. A compromised port silently copies contacts, photos, saved logins,
              and authenticator secrets the moment a phone trusts the connection.
            </p>
          </div>
          <ul className="bue-facts">
            <li>A normal AC wall socket carries power only — no data pins, no attack surface.</li>
            <li>Your own cable and charger are hardware you control end-to-end.</li>
            <li>&quot;Charge-only&quot; cables and USB data-blockers exist and stop this cold.</li>
          </ul>
          <button type="button" className="btn bue-continue" onClick={onContinue}>
            See the safe way to charge
          </button>
        </div>
        <div className="bue-art" aria-hidden>
          <img src="/cdn/sim/remote-work/explainers/badusb_explainer.jpg" alt="" />
        </div>
      </div>
    </div>
  );
}
